export const getUserType = user => {
  if (!user || !user?.id) return null;
  return user?.attributes?.profile?.publicData?.userType;
};

export function simpleHash(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

/**
 * Checks if an array is valid (not null, undefined, or empty).
 * @param {array} arr - The array to check.
 * @returns {boolean} True if the array is valid, false otherwise.
 */
export const isArrayLength = arr => {
  // Check if the input parameter is an array and has a length greater than zero.
  return Array.isArray(arr) && (arr.length > 0 ?? false);
};

const SMALL_WORDS = new Set(['and', 'or', 'the', 'a', 'an', 'of', 'to', 'in', 'on', 'for']);

export const formatCategoryLabel = (label = '') => {
  const s = String(label || '').trim();
  if (!s) return '';

  // Normalize spacing around '&'
  const normalized = s.replace(/\s*&\s*/g, ' & ');

  return normalized
    .split(/\s+/)
    .map((word, idx, arr) => {
      if (word === '&') return '&';

      const lower = word.toLowerCase();
      const isFirst = idx === 0;
      const isLast = idx === arr.length - 1;

      // keep small words lowercase unless first/last (e.g., "Stone and Tile")
      if (!isFirst && !isLast && SMALL_WORDS.has(lower)) return lower;

      // Title-case (handles letters/numbers safely)
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();
};


export const formatDimensions = publicData => {
  if (!publicData) return null;

  const { width, length, height } = publicData;

  // Only show if at least one dimension exists
  if (!width && !length && !height) return null;

  const parts = [];

  if (width) parts.push(`${width}ʺW`);
  if (length) parts.push(`${length}ʺD`);
  if (height) parts.push(`${height}ʺH`);

  return parts.join(' × ');
};
